import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Logo from '../assets/img/logo/logo.webp';
import Navbar from './NavBar';

const Container = styled.div`
  width: min(100%, 1800px);
  margin: 20px auto 0;
  border-radius: 50px;
  background-color: #ffffffae;
  box-shadow: 0 4px 6px rgba(241, 134, 13, 0.79);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;

  @media (max-width: 1024px) {
    margin: 10px auto;
    border-radius: 50px;
    padding: 10px 10px;
  }
`;

const LogoContainer = styled(Link)`
  padding: 0px;
  margin-left: 2rem;
  display: flex;
  align-items: center;
  text-decoration: none; /* чтобы не было подчеркивания */
  color: inherit; /* чтобы цвет не ломался */

  @media (max-width: 480px) {
    margin-left: 1rem;
    padding: 0px;
  }
`;

const Logoimg = styled.img.attrs({ width: 180, height: 196 })`
  width: 80px;
  padding-top: 8px;
  padding-bottom: 8px;
  height: auto;

  @media (max-width: 1024px) {
    width: 70px;
    margin: 0px;
    padding: 0px;
  }

  @media (max-width: 480px) {
    width: 30px;
    margin: 0px;
    padding: 0px;
  }
`;

const Web = styled.span`
  font-size: 50px;
  font-weight: bold;
  margin-left: 10px;
  font-family: 'Pristina', Regular, cursive;
  color: #053969;

  @media (max-width: 1024px) {
    font-size: 28px;
    margin-left: 0px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
    margin-top: 5px;
  }
`;

const Store = styled(Web)`
  color: #dc0303;
  margin-left: -1px;
`;

const NavWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
`;

const Header = ({ onMobileMenuChange, homeData }) => {
  const header = homeData?.header;
  const { t } = useTranslation();
  return (
    <Container
      style={{
        backgroundColor: header?.background_color,
        boxShadow: header?.box_shadow,
      }}
    >
      <LogoContainer to="/" aria-label={t('aria.goHome')}>
        <Logoimg src={Logo} alt={t('common.logo', { defaultValue: 'Logo' })} />
        <Web style={{ color: header?.brand_web_color }}>{header?.brand_web_text}</Web>
        <Store style={{ color: header?.brand_store_color }}>{header?.brand_store_text}</Store>
      </LogoContainer>

      <NavWrap>
        <Navbar onMobileMenuChange={onMobileMenuChange} homeData={homeData?.navbar} />
      </NavWrap>
    </Container>
  );
};

export default Header;
